import { Box, Container, List, ListItem, ListItemButton, ListItemText, Typography, Paper } from "@mui/material";
import Link from "next/link";
import Page from "./Page";
import NextBreadcrumbs from "./NextBreadcrumbs";

const menuItems = [
    { label: "Climate Graphs", href: "/mesonet-climate/graphs" },
    { label: "Statistics and Records", href: "/mesonet-climate/stats" }
];

export default function MesonetClimateLayout({ children, activeTab }) {
    const breadcrumbTitle = activeTab === 1 ? "Stats" : "Graphs";

    return (
        <Page>
            <Container maxWidth="xl" sx={{ py: 5 }}>
                <NextBreadcrumbs title={breadcrumbTitle} />
                <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 3 }}>
                    <Typography variant="h3">Mesonet Climate</Typography>
                    <Paper
                        variant="outlined"
                        sx={{
                            width: "fit-content"
                        }}
                    >
                        <List sx={{ display: "flex", flexDirection: "row", p: 0 }}>
                            {menuItems.map((item, index) => (
                                <ListItem key={index} disablePadding>
                                    <Link href={item.href} passHref legacyBehavior>
                                        <ListItemButton
                                            component="a"
                                            selected={activeTab === index}
                                            sx={{
                                                whiteSpace: "nowrap",
                                                "&.Mui-selected": {
                                                    backgroundColor: "primary.main",
                                                    color: "primary.contrastText",
                                                },
                                                "&.Mui-selected:hover": {
                                                    backgroundColor: "primary.dark",
                                                }
                                            }}
                                        >
                                            <ListItemText primary={item.label} />
                                        </ListItemButton>
                                    </Link>
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Box>

                <Box sx={{ width: "100%" }}>
                    {children}
                </Box>
            </Container>
        </Page>
    );
}
